import React from "react";
import product_default from "../../../assets/product_default.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from "react-i18next";
import { Card,ListGroup } from "react-bootstrap";
import close_cross from "../../../assets/close_cross.svg";
import { useSelector } from "react-redux";

export function CurrentorderlistPage (props) {
  const language = useSelector((state)=>state?.languageState?.language)
    const { t } = useTranslation();
    return(
        <div className="current-order-list">
        <h5 className="title">
        {t("pages.storedetail.products.current_order")}
        </h5>
        {props?.cartdata?.map((item , index) =>
          item?.variation_deleted_at === null &&
          item?.product_deleted_at === null ? (
            <React.Fragment key={index?.toString()} >
            {/* {item?.out_of_stock === false && ( */}
              <Card className="product-list mb-3">
                  <LazyLoadImage
                    className="product-img"
                    alt=""
                    onError={(event) => {
                      event.target.src = product_default;
                    }}
                    src={
                      item?.images === null
                        ? product_default
                        : item?.img_url
                    }
                  />
                  <Card.Body className="product-detail p-0 ms-2">
                    <h5 className="title">
                        {language === "Tr"
                          ? item?.title_in_tr
                          : item?.product_name}
                      </h5>
                      {item?.variation_deleted_at === null &&
                        item?.product_deleted_at === null ? (
                          item?.out_of_stock === true && (
                            <h5
                              className="not_available"
                              style={{ fontSize: "13px", color: "red" }}
                            >
                              {t("pages.Out of Stock")}
                            </h5>
                          )
                        ) : (
                          <h5
                            className="not_available"
                            style={{ fontSize: "13px", color: "red" }}
                          >
                            {t("pages.Not available")}
                          </h5>
                        )}
                      <label>
                        {item?.discount !== null &&
                        item?.discount !== 0 &&
                        item?.discount < item?.price ? (
                          <>
                            <strong className="pr-color">
                              {" "}
                              {item?.discount +
                                process.env.REACT_APP_CURRENCY_SYMBOL}
                            </strong>{" "}
                            x {item?.quantity}
                          </>
                        ) : (
                          <>
                            <strong className="pr-color">
                              {" "}
                              {item?.price +
                              " " + process.env.REACT_APP_CURRENCY_SYMBOL}
                            </strong>{" "}
                            x {item?.quantity}
                          </>
                        )}
                      </label>
                </Card.Body>
                {
                  props?.close === true && (
                    <div
                    className="close-icon"
                    onClick={() => props?.removeProduct(item)}
                  >
                    <img
                      src={close_cross}
                      height="15"
                      width="15"
                      alt="close"
                      style={{ position: "absolute", }}
                    ></img>
                  </div>
                  )
                }
              </Card>
            {/* )} */}
            </React.Fragment>
            ) : (
                <React.Fragment key={index?.toString()} />
              )
        )}
       </div>
        )
    
}

export function OrdersummaryPage(props) {
  const { t } = useTranslation();
 return(
      <Card className="order-summary">
      <Card.Body className="p-3">
        <h5 className="header-title pr-color">
          {t("pages.payment_card.order_summary")}
        </h5>
        <div className="ph-4">
          <ListGroup>
            <ListGroup.Item className="d-flex align-center justify-content-between align-items-start">
              {t("pages.payment_card.subtotal")}{" "}
              <label className="secound-text">
                {typeof props?.amount?.sub_total === "undefined"
                  ? "0"
                  : props?.amount?.sub_total}{" "}
                {process.env.REACT_APP_CURRENCY_SYMBOL}
              </label>
            </ListGroup.Item>
            <ListGroup.Item className="d-flex align-center justify-content-between align-items-start">
              {t("pages.payment_card.vat")}{" "}
              <label className="secound-text">
                {typeof props?.amount?.vat_rate === "undefined"
                  ? "0"
                  : props?.amount?.vat_rate}{" "}
                {process.env.REACT_APP_CURRENCY_SYMBOL}
              </label>
            </ListGroup.Item>
            <ListGroup.Item className="d-flex align-center justify-content-between align-items-start">
              {t("pages.payment_card.discount")}{" "}
              <label className="secound-text">
                {typeof props?.amount?.discount === "undefined"
                  ? "0"
                  : props?.amount?.discount}{" "}
                {process.env.REACT_APP_CURRENCY_SYMBOL}
              </label>
            </ListGroup.Item>
            <ListGroup.Item className="d-flex border-bottom-1 align-center justify-content-between align-items-start">
              {t("pages.add_delivery.charges")}{" "}
              <label className="secound-text">
                {typeof props?.amount?.charges === "undefined"
                  ? "0"
                  : props?.amount?.charges}{" "}
                {process.env.REACT_APP_CURRENCY_SYMBOL}
              </label>
            </ListGroup.Item>
            <div className="d-flex align-center justify-content-between align-items-start mt-3">
              <h6>{t("pages.payment_card.totalamount")} </h6>
              <h6>
                {Number(
                  typeof props?.amount?.total_amount === "undefined"
                    ? "00.00"
                    : props?.amount?.total_amount +
                        (typeof props?.amount?.charges === "undefined"
                          ? 0
                          : props?.amount?.charges) -
                        (typeof props?.amount?.discount ===
                        "undefined"
                          ? 0
                          : props?.amount?.discount)
                ).toFixed(2)}{" "}
                {process.env.REACT_APP_CURRENCY_SYMBOL}
              </h6>
            </div>
          </ListGroup>
        </div>
      </Card.Body>
    </Card>
    )
}

